export default class ElementReferenceError extends Error {}

export const isElementReferenceError = (
  e: unknown
): e is ElementReferenceError => e instanceof ElementReferenceError;
